import React from 'react';
import {useSearchParams} from 'react-router-dom';
import environmentStore from '@di-shared/features/environment/environmentStore';
import VehicleInspectionNewReservationForm, {
  VehicleInspectionNewReservationStep,
} from '@di-shared/features/public-service/vehicle-inspection/reservation/VehicleInspectionNewReservationForm';
import useUrlQueryStore from '@shared/useUrlQueryStore';

export interface VehicleInspectionNewReservationPageProps {
  vin: string;
}

const STEP_KEY = 's';

function VehicleInspectionNewReservationPage({vin}: VehicleInspectionNewReservationPageProps): JSX.Element {
  const puid = environmentStore.getState().puid;
  const [searchParams] = useSearchParams();
  const selectedIndex = getSelectedIndex(searchParams.get('index'));

  const [stepStore, setStepStore] = useUrlQueryStore<{step: VehicleInspectionNewReservationStep}>(STEP_KEY, {
    step: VehicleInspectionNewReservationStep.STEP_1_INFO,
  });

  function updateStep(step: VehicleInspectionNewReservationStep, isReplace: boolean) {
    // STEP_1_DISCOUNT, STEP_2_BEFORE_PLACE 의 경우, 스탭 내에서 번외 스탭같은 개념임. 여기서 이탈할때는 replace 하는것이 플로우상 정확
    setStepStore({step}, isReplace);
  }

  return (
    <VehicleInspectionNewReservationForm
      vin={vin}
      puid={puid}
      selectedIndex={selectedIndex}
      step={stepStore.step}
      updateStep={updateStep}
    />
  );
}

function getSelectedIndex(rawIndex: string | null) {
  try {
    return rawIndex ? Number(rawIndex) : 0;
  } catch {
    return 0;
  }
}

export default VehicleInspectionNewReservationPage;
